import {
  IS_MOBILE_CHECK,
  IS_LOADING,
  DEFAULT_SELECTED_NODE,
  DEFAULT_SELECTED_SUBCAT
} from "../types.js";

const initialState = {
  isMobile: false,
  loading: true,
  defaultSelectedNode: ""
};


const mainReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case IS_MOBILE_CHECK:
      return { ...state, isMobile: payload };
    case IS_LOADING:
      return { ...state, loading: false };
    case DEFAULT_SELECTED_NODE:
      return { ...state, defaultSelectedNode: payload };
    case DEFAULT_SELECTED_SUBCAT:
      return { ...state, defaultSelectedSubcat: payload };
    default:
      return state;
  }
};

export default mainReducer;
